import React from 'react';
import './styles.scss';
import { Button } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import stringJp from '../../constants/stringJP';

function CancelInfomation(props) {

    let history = useHistory();
    const { account_id } = props;

    const handlClick = (account_id) => {
        history.push(`/add-member?account_id=${account_id}`, {isCancel : true});
    };

    return (
        <div className="cancel-information">
            <div className="cancel-info">
                <Button
                    variant="contained"
                    component="span"
                    className="button-cancel"
                    onClick={() => handlClick(account_id)}
                >
                    <p>{stringJp.label_button_cancel}</p>
                </Button>
            </div>
        </div>
    );
};

export default CancelInfomation;